module.exports = __webpack_public_path__ + "public/img/5.b5eac828.png";